module.exports = __webpack_public_path__ + "img/key-tags.0066c280.jpg";